<script>
	export let active = false
  export let disabled = false
	export let on_fill = false
</script>

<span on:click class:disabled class:active class:on_fill>
	<slot/>
</span>

<style>
	span {
		cursor: pointer;
    color: var(--c-text-faded);
		user-select: none;
	}
	span:hover {
		color: var(--c-text);
	}
	span.active,
	span:active {
		color: var(--c-accent);
  }
  span.disabled,
	span.on_fill.disabled {
		opacity: 0.5;
		cursor: default;
		pointer-events: none;
	}
	
	span.on_fill {
		color: var(--c-text-on-fill);
	}
	span.on_fill:hover {
		color: var(--c-text-on-fill-hover);
	}
	span.on_fill.active {
		color: var(--c-accent-teal);
  }
	span.on_fill:active {
		color: var(--c-text-on-fill-hover);
	}
</style>